<script>
    import Twitter from './Twitter.svelte';
    import WidgetSentiment from './WidgetSentiment.svelte';
    import SearchUser from './SearchUser.svelte';
    import { userStore, tweetStore } from './stores.js';
    import { SENTIMENT_BASE_URL, HIGHLIGHT_COLOUR } from './constants.js';

    let username;
    let url;
    let tweets;
    let tweetUrl = '-';
    let sentiment;
    let sentimentReason;
    let showTwitter = false;
    let showMenu = false;
    let showSearch = false;
    let clientX;
    let clientY;

    userStore.subscribe(({ username: newUsername, url: newUrl}) => {
        username = newUsername;
        url = newUrl;
        showMenu = false;
        showTwitter = false; 
    });
    tweetStore.subscribe(({ tweets: newTweets }) => {
        tweets = newTweets;
    });

    async function handleClick(tweet) {
        showTwitter = false;
        tweetUrl = tweet;
        sentiment = null;
        sentimentReason = null;
        
        // Use setTimeout to delay the execution
        setTimeout(() => {
            showTwitter = true;
            getSentiment(tweet);
        }, 0);
    }
    
    async function getSentiment(tweet) {
        // const response = await fetch(`https://sentiment.graph.gv.my/?tweeturl=${tweet}`);
        const response = await fetch(`${SENTIMENT_BASE_URL}?tweeturl=${tweet}`);
        if (response.ok) {
            const data = await response.json();
            sentiment = data.content.split('|')[0];
            sentimentReason = data.content.split('|')[1];
        } else {
            sentiment = 'Error';
            sentimentReason = 'Error';
        }
    }

    function handleMenuClick(event) {
        showMenu = true;
        clientX = event.clientX;
        clientY = event.clientY;
    }

    function handleHighlightClick(event) {
        const node = document.getElementById(username);
        if (node) {
            node.style.fill = HIGHLIGHT_COLOUR;
        }
    }

    function handleUsernameSelected(event) {
        showSearch = false;
        username = event.detail;
        const node = document.getElementById(username);
        if (node) {
            node.style.fill = HIGHLIGHT_COLOUR;
        }
    }

    function handleSearchClick(event) {
        showSearch = true;
        showMenu = false;
    }


</script>
<div class="bg-blueish-black border-4 rounded-lg left-10 space-x-2 p-3">
    <p class="text-white pl-2">Username</p>
    {#if showSearch}
        <SearchUser on:usernameSelected={handleUsernameSelected} />
    {:else}
        <a href={url} target="_blank" class="" on:click|preventDefault="{(event) => handleMenuClick(event)}">
            <div class="text-white font-bold text-2xl overflow-hidden overflow-ellipsis whitespace-nowrap pl-2 -mt-6">{username === '-' ? username : '@'+username}</div>
        </a>
    {/if}
    <p class="text-white pt-3">Tweets</p>
    {#each tweets as tweet}
        <a href={tweet} target="_blank" on:click|preventDefault={handleClick(tweet)}>
            <div class="text-white font-bold overflow-hidden overflow-ellipsis whitespace-nowrap pl-2 -mt-6">{tweet}</div>
        </a>
    {/each}
</div>
{#if showTwitter && tweetUrl != '-' && sentiment} 
    <WidgetSentiment { sentiment } { sentimentReason } />
{/if}
<div class="p-1 absolute top-25 right-20">
    {#if showTwitter && tweetUrl != '-' } 
        <Twitter { tweetUrl } />
    {/if}
</div>

{#if showMenu}
    <div class="absolute top-0 left-0 bg-blueish-black border-2 rounded p-3 shadow text-white" style="left: {clientX}px; top: {clientY}px;">
        <ul>
            <li class="hover:bg-purple-blue rounded p-2"><a href={url} target="_blank" >View on Twitter</a></li>
            <li class="hover:bg-purple-blue rounded p-2"><a href='#highlight' on:click|preventDefault="{(event) => handleHighlightClick(event)}">Highlight @{username}</a></li>
            <li class="hover:bg-purple-blue rounded p-2"><a href='#searchUser' on:click|preventDefault="{(event) => handleSearchClick(event)}">Search Username</a></li>
        </ul>
    </div>
{/if}